import React, {Component} from 'react';
import Menu from '../Components/Menu';

import axios from 'axios';
import AuthService from "../services/auth.service";
import './Profile.css';

class   Profile extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            username: "",
            password: "",
            loading:false,
            id:[],
            detail:[],
            edu:[],
            download:[],
            userPassword:"",
            userPassword1:"",
            show:false,
            show1:false
          };
    }
 
    checkPassword(){
        if (this.userPassword==this.userPassword1){
            this.restPassword()
        }
        else{
            alert("Please check password")
        }

    }


    restPassword(){
        const user = AuthService.getCurrentUser();
        const USR_TOKEN = localStorage.getItem("userToken")
        const resetData= {
            new_password:this.userPassword1
        }
        axios.put(process.env.REACT_APP_API_URL + 'api/resource/User/'+user.uid,resetData,{
            headers : {'Authorization' : USR_TOKEN, 
            'content-type': 'application/json'}
        })                
        .then(response=>{
            //this.setState({userlogin:response.data})
            //console.log(response.data)
            alert("Password updated")

        })
            .catch(
                err =>{ console.log(err)}
        )

    }

    fetchData(name){
        const USR_TOKEN = localStorage.getItem("userToken")
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Employee/'+name), {
            headers : {'Authorization' : USR_TOKEN, 
        'content-type': 'application/json'}
        })
        .then(response=>{
            //alert('ok')
                //this.setState({detail:response.data.data[0]})
                this.setState({edu:response.data.data.education})
                this.setState({download:response.data.data.employee_downloads})
               // console.log(response.data.data.education)

        })
        .catch(err=>{
            //window.location.href = "/";
            //this.setState({name:response.data['data'][0]})
            //console.log("done")
        })


    }

    async componentDidMount(){
       
        AuthService.getCurrentUser();
        const user = AuthService.getCurrentUser();
        const USR_TOKEN = localStorage.getItem("userToken")
        console.log(user)
        this.setState({ id:user })
            if(!user){
                this.setState({ loading:false });
                window.location.href = "/login";
            }  
            else{
                this.setState({ loading:true });
            } 

            axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Employee?fields=["employee_name","name","image","user_id","employment_type","cell_number","person_to_be_contacted","relation","salary_mode","provident_fund_account","permanent_address","marital_status","blood_group","status","gender","date_of_birth","date_of_joining","designation","personal_email","emergency_phone_number","bank_name","bank_ac_no"]&filters=[["user_id","=","'+user.uid+'"]]'), {
                headers : {'Authorization' : USR_TOKEN, 
            'content-type': 'application/json'}
            })
            .then(response=>{
                //alert('ok')
                    this.setState({detail:response.data.data[0]})
                    //this.setState({earn:response.data.data.earnings})
                   // console.log(response.data.data)
                   this.fetchData(response.data.data[0].name)
    
            })
            .catch(err=>{
                //window.location.href = "/";
                //this.setState({name:response.data['data'][0]})
                //console.log("done")
            })

    }
  render() {
return this.state.loading ? 
            <div className="container-fluid emp-profile">
                <form method="post">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="profile-img">
                                <img src={process.env.REACT_APP_API_URL+this.state.detail.image} alt=""/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="profile-head">
                                <h5>{this.state.detail.employee_name}</h5>
                               {/*  <h6>{this.state.detail.employment_type}</h6> */}
                                {/* <p className="proile-rating">RANKINGS : <span>8/10</span></p> */}
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">About</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Qualification</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="download-tab" data-toggle="tab" href="#download" role="tab" aria-controls="download" aria-selected="false">Downloads</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="reset-tab" data-toggle="tab" href="#reset" role="tab" aria-controls="reset" aria-selected="false">Reset Password</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="tab-content profile-tab" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Full Name</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.employee_name}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Employment Type</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.employment_type}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Mobile</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.cell_number}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Emergency Contact Name</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.person_to_be_contacted}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Relation</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.relation}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>User ID</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.user_id}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Salary Mode</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.salary_mode}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Provident Fund Account</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.provident_fund_account}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Permenent Address</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.permanent_address}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Marital Status</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.marital_status}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Blood Group</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.blood_group}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Status</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.status}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Gender</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.gender}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Date of Birth</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.date_of_birth}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Date of Joining</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.date_of_joining}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Designation</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.designation}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Email</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.personal_email}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Emergency Phone</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.emergency_phone_number}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Bank Name</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.bank_name}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Bank A/C No</label>
                                        </div>
                                        <div className="col-md-6">
                                            <p>{this.state.detail.bank_ac_no}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade mb-5" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <table className="table table-bordered">
                                        <thead className="">
                                            <tr>
                                                <th>Sr</th>
                                                <th>School/University</th>
                                                <th>Qualification</th>
                                                <th>Level</th>
                                                <th>Year of passing</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.edu ?  this.state.edu .map((itm,k)=>{
                             
                                                 return(

                                            <tr key={k}>
                                                <td>{k+1}</td>
                                                <td>{itm.school_univ}</td>
                                                <td>{itm.qualification}</td>
                                                <td>{itm.level}</td>
                                                <td>{itm.year_of_passing}</td>
                                            </tr>

                                                )
                                                }):""}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="tab-pane fade mb-5" id="download" role="tabpanel" aria-labelledby="download-tab">
                                    <table className="table table-bordered">
                                        <thead className="">
                                            <tr>
                                                <th width="20%">Sr</th>
                                                <th>title</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.download ?  this.state.download .map((itm,k)=>{
                             
                                                 return(

                                            <tr key={k}>
                                                <td>{k+1}</td>
                                                <td><a href={process.env.REACT_APP_IMAGE+itm.attach} target="_blank">{itm.title}</a></td>
                                                
                                            </tr>

                                                )
                                                }):""}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="tab-pane fade mb-5" id="reset" role="tabpanel" aria-labelledby="reset-tab">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="form-label">Enter New Password</label>
                                                <div className="form-control-wrap">
                                                    <input type={this.state.show1 ? "text":"password"} className="form-control form-control-lg" placeholder="Enter new password " Value={this.userPassword}
                                                     onChange={e => this.userPassword = e.target.value}/>
                                                     {this.state.show1?<a href="#0" onClick={()=>this.setState({ show1:!this.state.show1 })}><i className="fa fa-eye-slash icn-position"></i></a>:<a href="#0" onClick={()=>this.setState({ show1:!this.state.show1 })}><i className="fa fa-eye icn-position"></i></a>}
                                                </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Re-Enter New Password</label>
                                                <div className="form-control-wrap">
                                                    <input type={this.state.show ? "text":"password"} className="form-control form-control-lg" placeholder="Re-Enter your New Password "
                                                        onChange={e => this.userPassword1 = e.target.value} />
                                                    {this.state.show?<a href="#0" onClick={()=>this.setState({ show:!this.state.show })}><i className="fa fa-eye-slash icn-position"></i></a>:<a href="#0" onClick={()=>this.setState({ show:!this.state.show })}><i className="fa fa-eye icn-position"></i></a>}
                                                </div>
                                        </div>
                                    </div>
                                    <div className="col-12 mt-4">
                                       
                                        <a href="#0" className="btn btn-primary float-right" type="button" onClick={(e) => this.checkPassword()} ><b>Reset Password</b></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>           
            </div>:""
}
}
export default Profile;